import { style } from "typestyle";
import { COLOR_01, FONT_WEIGHT_LIGHT, MARGINS_PX } from "../../../constants";
import { mixinFont } from "../../../style.mixin";

export const checkListClassName = style({
    display: 'block',
    listStyle: 'none',
    margin: 0,
    padding: 0
});

export const checkListItemClassName = style({
    display: 'block',
    position: 'relative',
    margin: `0 0 ${MARGINS_PX / 2}px 0`,
    padding: '0 0 0 20px',
    ...mixinFont(12, FONT_WEIGHT_LIGHT),

    $nest: {
        'img': {
            display: 'none'
        }
    }
});

export const checkListActiveItemClassName = style({
    color: COLOR_01 + '!important',

    $nest: {
        'img': {
            display: 'block!important',
            position: 'absolute',
            left: 0,
            top: '3px'
        }
    }
});
